export default "assets/images/pattern-1f9b6461.jpg";